import { ConnectorsTableconstant } from "./ConnectorsTableConstant";

const ConnectorsTableAction = {};

ConnectorsTableAction.getConnectorsTable = () => {
  return {
    type: ConnectorsTableconstant.CONNECTORS_TABLE_SAGA,
  };
};

ConnectorsTableAction.postPowerMapAction = (payload) => {
  return {
    type: ConnectorsTableconstant.POST_POWER_MAP_SAGA,
    payload: payload,
  };
};
export { ConnectorsTableAction };
